
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PermissionAlertProps {
  onRequestPermission: () => Promise<void>;
}

const PermissionAlert = ({ onRequestPermission }: PermissionAlertProps) => {
  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Notification Permission Required</AlertTitle>
      <AlertDescription className="mt-2">
        <p className="mb-3">
          You need to allow notifications in your browser settings for this app to work properly.
          The app is currently running in demo mode with simulated notifications.
        </p>
        <Button 
          onClick={onRequestPermission} 
          variant="outline" 
          size="sm"
          className="mt-2"
        >
          Request Permission Again
        </Button>
        <p className="mt-4 text-xs">
          If the button doesn't work, you'll need to enable notifications manually in your browser settings:
          <br />Site settings → Notifications → Allow
        </p>
      </AlertDescription>
    </Alert>
  );
};

export default PermissionAlert;
